import { db } from '../lib/firebase';
import { collection, addDoc, query, where, orderBy, getDocs, Timestamp } from 'firebase/firestore';

export type ActivityAction = 'create' | 'update' | 'delete' | 'login' | 'logout' | 'login_failed' | 'lock' | 'unlock' | 'export' | 'import';

export interface ActivityLog {
  id?: string;
  userId: string;
  userEmail: string;
  userName: string;
  action: ActivityAction;
  resource: string;
  resourceId?: string;
  details?: string;
  timestamp: Date;
  ipAddress?: string;
}

export const activityLogService = {
  async log(entry: Omit<ActivityLog, 'id' | 'timestamp'>) {
    try {
      await addDoc(collection(db, 'activityLogs'), {
        ...entry,
        timestamp: new Date()
      });
    } catch (error) {
      console.error('Error writing activity log:', error);
    }
  },

  async getLogs(filters?: {
    userId?: string;
    action?: ActivityAction;
    resource?: string;
    dateFrom?: Date;
    dateTo?: Date;
    limit?: number;
  }): Promise<ActivityLog[]> {
    try {
      let q = collection(db, 'activityLogs');
      let constraints: any[] = [orderBy('timestamp', 'desc')];

      if (filters?.userId) {
        constraints.unshift(where('userId', '==', filters.userId));
      }
      if (filters?.action) {
        constraints.unshift(where('action', '==', filters.action));
      }
      if (filters?.resource) {
        constraints.unshift(where('resource', '==', filters.resource));
      }

      const querySnapshot = await getDocs(query(q, ...constraints));
      let logs = querySnapshot.docs.map(doc => {
        const data = doc.data();
        return {
          ...data,
          id: doc.id,
          timestamp: data.timestamp?.toDate ? data.timestamp.toDate() : new Date(data.timestamp)
        } as ActivityLog;
      });

      if (filters?.dateFrom) {
        logs = logs.filter(l => l.timestamp >= filters.dateFrom!);
      }
      if (filters?.dateTo) {
        logs = logs.filter(l => l.timestamp <= filters.dateTo!);
      }

      const limit = filters?.limit || 200;
      return logs.slice(0, limit);
    } catch (error) {
      console.error('Error fetching activity logs:', error);
      return [];
    }
  }
};
